import { createContext, use } from "react";

export function createStrictContext<T>() {
  const Context = createContext<T | null>(null);

  const useStrictContext = () => {
    const value = use(Context);
    if (!value) {
      throw new Error(`Value not found in context.`);
    }
    return value;
  };

  return [Context, useStrictContext] as const;
}
